import { render, staticRenderFns } from "./DataLayer.vue?vue&type=template&id=dec9a5dc"
import script from "./DataLayer.vue?vue&type=script&lang=js"
export * from "./DataLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports